import { render, staticRenderFns } from "./userProfile.vue?vue&type=template&id=3ce7535b&scoped=true"
import script from "./userProfile.vue?vue&type=script&lang=js"
export * from "./userProfile.vue?vue&type=script&lang=js"
import style0 from "./userProfile.vue?vue&type=style&index=0&id=3ce7535b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce7535b",
  null
  
)

export default component.exports